<template>
  <inertia-link
    :href="$route('home.vlogs.show', { slug: data.slug })"
    class="item"
  >
    <div
      class="thumbnail"
      role="button"
      @click.stop.prevent="$root.$emit('playVlog', data)"
    >
      <img v-lazy="data.thumbnail" :alt="data.alt || data.title" />
      <button
        class="play-btn"
        type="button"
        @click.stop.prevent="$root.$emit('playVlog', data)"
      >
        <i class="fas fa-play"></i>
      </button>
    </div>
    <div class="content">
      <h3 class="title wrap-text-2">{{ data.title }}</h3>
      <div class="tags">
        <span v-for="tag in hashTags" :key="tag" class="tag">#{{ tag }}</span>
      </div>
    </div>
  </inertia-link>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hashTags() {
      return this.seoTagsToArr(this.data.seo_tags);
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  .thumbnail {
    display: block;
    height: 200px;
    overflow: hidden;
    border-radius: var(--border-radius);
    background: var(--card-color);
    box-shadow: var(--box-shadow);
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .play-btn {
      --size: 3rem;
      height: var(--size);
      width: var(--size);
      font-size: calc(var(--size) / 2);
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 1;
      transition: all 0.25s ease;
      color: var(--primary-contrast);
      background: var(--primary);
      border-radius: 50%;
      box-shadow: none;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all 0.25s ease;
    }

    &:hover {
      .play-btn {
        transform: translate(-50%, -50%) scale(1.1);
      }
      &:after {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
  .content {
    padding: 0.6rem;
    padding-bottom: 0;
    margin-bottom: 1.2rem;
    .title {
      font-size: 1.2rem;
      line-height: 1.1;
      font-weight: bold;
      font-family: var(--font-family);
      margin-bottom: 0;
      color: var(--dark);
    }

    .tags {
      margin-top: 0.2rem;
      .tag {
        font-size: 0.9rem;
        font-weight: 500;
        color: var(--dark);
        opacity: 0.6;
        margin-right: 0.5rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>